<template>
    <b-row>
        <b-col cols="12" class="d-flex justify-content-center"
            >{{ from }} a {{ to }} de {{ total }}</b-col
        >
        <b-col cols="12" class="d-flex justify-content-between">
            <b-btn
                size="sm"
                class="mr-3"
                :variant="current_page === 1 ? 'secondary' : 'primary'"
                @click="$emit('change-page', 1)"
                >Primera</b-btn
            >
            <b-btn-group>
                <b-btn
                    :variant="p === current_page ? 'success' : 'primary'"
                    size="sm"
                    v-for="p in pages"
                    :key="p"
                    @click="$emit('change-page', p)"
                    >{{ p }}</b-btn
                >
            </b-btn-group>
            <b-btn
                size="sm"
                class="ml-3"
                :variant="current_page === last_page ? 'secondary' : 'primary'"
                @click="$emit('change-page', last_page)"
                >Última</b-btn
            >
        </b-col>
    </b-row>
</template>
<script>
export default {
    props: ['current_page', 'from', 'to', 'last_page', 'per_page', 'total'],
    data: () => ({}),
    computed: {
        fromPage() {
            return Math.max(1, this.current_page - 5)
        },
        toPage() {
            return Math.min(this.last_page, this.fromPage + 9)
        },
        pages() {
            const pages = []
            for (let i = this.fromPage; i <= this.toPage; i++) {
                pages.push(i)
            }
            return pages
        },
    },
    methods: {},
}
</script>
